const gymnases = [
    {
        id: 1,
        name: "GYMNASE GASTON TURPIN",
        latitude: 47.22387972225693,
        longitude: -1.5409190693148886,
        address: "33 Rue Gaston Turpin, Nantes",
    },
    {
        id: 2,
        name: "GYMNASE DU PORT BOYER",
        latitude: 47.24103363485088,
        longitude: -1.5377076213215606,
        address: "Rue du Port Boyer, Nantes",
    },
    {
        id: 3,
        name: "GYMNASE BOTTIÈRE CHENAIE",
        latitude: 47.237625960225195,
        longitude: -1.5137681654998734,
        address: "16 Rue des Carnavaliers, Nantes",
    },
    {
        id: 4,
        name: "GYMNASE DE LA HALVEQUE",
        latitude: 47.25393909436048,
        longitude: -1.5171958652197062,
        address: "2 Rue du Moulin de la Halveque, Nantes",
    },
    {
        id: 5,
        name: "GYMNASE DE DOULON",
        latitude: 47.23771938223233,
        longitude: -1.5099300501573758,
        address: "1 Rue de la Basse Chenaie, Nantes",
    },
    {
        id: 6,
        name: "GYMNASE JEAN VINCENT",
        latitude: 47.26180392579064,
        longitude: -1.5138901483064773,
        address: "Rue Marcel et Marie Michel, Nantes",
    },
];

export default gymnases;
